module.exports = __webpack_public_path__ + "img/nav-logo.bee17bf4.png";